<template lang="html">
  <select></select>
</template>

<script>
import isEqual           from 'lodash/isEqual'
import first             from 'lodash/first'

export default {
  model: {
    prop: 'modelValue',
    event: 'input'
  },
  props: ['options', 'value', 'modelValue', 'model', 'dependent', 'dependon'],

  computed: {
    // prepare for select 2 (id, text)
    _options: {
      get: function() {
        let options = '';
        if (this.options) {
          // TODO: get rid off "text"
          options = this.options.map(
            function(item, index) {
              if (!item.id && item.text) {
                item = {
                  id: item.text,
                  text: item.text
                };
              }
              else if (typeof item == 'string') {
                item = {
                  id: item,
                  text: item
                };
              }
              else if ( item.id == 0 || !item.text.length ) {
                item = {
                  id: "",
                  text: ""
                };
              }
              return item;
            }
          );
        }
        return options;
      },
      // set: function(options) {
      //   // var vm = this;
      //   console.log("set options", options);
      // }
    }
  },

  methods: {
    toggle: function() {
      let value;
      let vm = this;
      let s2_el = $(vm.$el);
      value = vm.modelValue;
      if (typeof value !== 'object' && this.isInt(value) && /^\d+$/.test(value)) {
        value = parseInt(value);
      }
      vm.$emit('input', value);
      s2_el.val(value).trigger('change.select2');
    },
    isInt: function(value) {
      return !isNaN(value) && (function(x) { return (x | 0) === x; })(parseFloat(value))
    }
  },

  watch: {
    modelValue(newValue, oldValue) {
      // console.log("watch newValue", newValue);
      // console.log("watch oldValue", oldValue);
      if (newValue != oldValue) {
        this.toggle();
      }
    },
    value: function(value) {
      // update value
      // console.log("s2 watch value", value);
      $(this.$el).val(value);
      // vm.$emit('input', value);
    },
    _options: function(_options, _old_options) {
      if (!isEqual(_options, _old_options)) {

        let vm = this;
        var s2_el = $(vm.$el);
        var s2_papa = $(vm.$el).parent('div');

        // update options
        s2_el
            .empty()
            .select2("destroy")
            .select2({
              data: _options,
              dropdownParent: s2_papa
            });

        if (vm.dependon) {

        } else {
          s2_el
          .one('change', function (event) {
            var $searchfield = s2_el.parent().find('.select2-search__field');
            $searchfield.prop('disabled', true);
          })
          ;
        }
        // console.log('update options', vm.modelValue);
        /*
        if (vm.modelValue) {
            s2_el.val(vm.modelValue);
            vm.$emit('input', vm.modelValue);
          } else {
            // first
          }
        s2_el.trigger('change');
        */
        // setTimeout(function () {
          if (vm.modelValue) {
            if (!vm.dependon) {
              s2_el.val(vm.modelValue).trigger('change');
            } else {
              s2_el.trigger('change'); // auto change estate_type on change estate_group
            }
          } else {
            // s2_el.trigger('change');
          }
        // }, 1000);

      }
    }
  },


  mounted: function() {
    var vm = this;
    var s2_el = $(this.$el);
    var s2_papa = $(vm.$el).parent('div');

    s2_el
      // init select2
      .select2({
        data: this._options,
        dropdownParent: s2_papa
      })
      // emit event on change.
      .on('change', function(e) {
        // vanilla get selected values for multiples
        // console.log("e", [].slice.call(e.target.selectedOptions).map(a => a.value));
        vm.$emit('input', s2_el.val());
        vm.$emit('change', s2_el.val());
        // vm.$parent.$emit('child-coucou', vm);
      })
      // .on('select2:opening select2:closing', function (event) {
        .one('change', function (event) {
        var $searchfield = s2_el.parent().find('.select2-search__field');
        $searchfield.prop('disabled', true);
      })
      ;
    // инициализируем модель на основе первого пункта опций или дефолтной модели
    // TODO: иначе placeholder

    // console.log("mounted vm.modelValue", vm.modelValue);

    setTimeout(function () {
      if (vm.modelValue) {
        s2_el.val(vm.modelValue).trigger('change');
      } else {
        s2_el.trigger('change');
      }
    }, 100);
  },
  beforeDestroy() {
    //
    // QUESTION: чистим модель?  только для зависимых селектов?
    // console.log('this.dependon NULL');
    if (this.dependon) {
      this.$emit('input', null);
    }
  },
  destroyed: function() {
    $(this.$el).off().select2('destroy')
  }
}
</script>



// WEBPACK FOOTER //
// src/components/select2.vue